import React from 'react'

interface IconProps {
  className?: string
}

const SoccerBall = ({ className }: IconProps) => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
  >
    <path
      d="M13.5 2.5L14.5 4.5L12 6L9.5 4.5L10.5 2.5M16.9064 20.2033L14.9035 19.2092L15.9956 16.5059L18.8947 16.1975L19.3011 18.3963M7.19296 20.2033L9.19588 19.2092L8.10379 16.5059L5.20468 16.1975L4.79824 18.3963M21.4635 10.4763L20.0464 12.206L17.6561 10.5367L18.0042 7.6421L20.2382 7.73797M2.40842 10.4763L3.82552 12.206L6.21583 10.5367L5.86779 7.6421L3.63378 7.73797M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 9.5L9.5 11.5L10.5 14H13.5L14.5 11.5L12 9.5Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SoccerBall
